import React, { useEffect, useState } from "react"
import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import AHMIS, { API_URL } from "../../../api/api";
import AddAlertMessage from "../../../components/alert/Alert";
import { ERROR, SOMETHING_WENT_WRONG, SUCCESS } from "../../../utils/constants";

const AvailableServices = () => {

  const [services, setServices] = useState([])

  useEffect(() => {
    getSettingData()
  }, [])

  const getSettingData = () => {
    AHMIS.get(API_URL.applicationSetting)
      .then(response => {
        let jsondata = response.data
        if (jsondata.type === SUCCESS) {
          setServices(jsondata.data?.availableServices || {});
        } else {
          AddAlertMessage({ type: jsondata.type, message: jsondata.message })
        }
      })
      .catch(error => {
        AddAlertMessage({ type: ERROR, message: SOMETHING_WENT_WRONG });
      });
  };

  const circle = (service, index) => {
    return services.includes(service) ? <span className="round">{index}</span> : <span>{index}</span>;
  };

  return (
    <>
      <TableContainer classes={{ root: "fixed-head-table-container" }}  >
        <Box mt={4}>
          <Typography variant="body1" className="report-heading">उपलब्ध सेवा</Typography>
        </Box>
        <Table classes={{ root: "table-bordered normal-spacing" }} size="small" aria-label="Available-Services">
          <TableHead classes={{ root: "align-center fixed-header header-sm" }}>
            <TableRow>
              <TableCell>क्रसं</TableCell>
              <TableCell>उपलब्ध सेवा</TableCell>
              <TableCell>कोड</TableCell>
            </TableRow>
          </TableHead>
          <TableBody classes={{ root: "align-center" }}>
            <TableRow>
              <TableCell>1</TableCell>
              <TableCell>उपचार सेवा</TableCell>
              <TableCell>{circle("TREATMENT_SERVICE", 1)}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>2</TableCell>
              <TableCell>पञ्चकर्म सेवा</TableCell>
              <TableCell>{circle("PANCHAKARMA_SERVICE", 2)}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>3</TableCell>
              <TableCell>शल्य सेवा</TableCell>
              <TableCell>{circle("SURGERY_SERVICE", 3)}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>4</TableCell>
              <TableCell>योगसेवा</TableCell>
              <TableCell>{circle("YOGA_SERVICE", 4)}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>5</TableCell>
              <TableCell>जेष्ठ नागरिक सेवा</TableCell>
              <TableCell>{circle("SENIOR_CITIZEN_SERVICE", 5)}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>6</TableCell>
              <TableCell>स्तनपायी आमा तथा मातृशिशु सेवा</TableCell>
              <TableCell>{circle("MOTHER_CHILD_SERVICE", 6)}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>7</TableCell>
              <TableCell>स्त्री प्रसूति सेवा</TableCell>
              <TableCell>{circle("GYNECOLOGY_SERVICE", 7)}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>8</TableCell>
              <TableCell>विद्यालय आयुर्वेद तथा योग शिक्षा</TableCell>
              <TableCell>{circle("SCHOOL_AYURVEDA_YOGA_EDUCATION", 8)}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>9</TableCell>
              <TableCell>गाँउघर शहरी क्लिनिक</TableCell>
              <TableCell>{circle("RURAL_URBAN_CLINIC", 9)}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>10</TableCell>
              <TableCell>नसर्ने रोग तथा मानसिक रोग सेवा</TableCell>
              <TableCell>{circle("NCD_MENTAL_HEALTH_SERVICE", 10)}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>11</TableCell>
              <TableCell>नागरिक आरोग्य</TableCell>
              <TableCell>{circle("CITIZEN_HEALTH_SERVICE", 11)}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>12</TableCell>
              <TableCell>काय चिकित्सा सेवा</TableCell>
              <TableCell>{circle("KAYACHIKITSA_SERVICE", 12)}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>13</TableCell>
              <TableCell>शालक्य सेवा</TableCell>
              <TableCell>{circle("SHALAKYA_SERVICE", 13)}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>14</TableCell>
              <TableCell>अन्तरङ्ग सेवा</TableCell>
              <TableCell>{circle("ANTARANG_SERVICE", 14)}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>15</TableCell>
              <TableCell>वालरोग स्वास्थ्य सेवा</TableCell>
              <TableCell>{circle("PEDIATRIC_SERVICE", 15)}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>16</TableCell>
              <TableCell>आकस्मिक सेवा</TableCell>
              <TableCell>{circle("EMERGENCY_SERVICE", 16)}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>17</TableCell>
              <TableCell>अकुपञ्चर सेवा</TableCell>
              <TableCell>{circle("ACUPUNCTURE_SERVICE", 17)}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>18</TableCell>
              <TableCell>फिजियोथेरापी सेवा</TableCell>
              <TableCell>{circle("PHYSIOTHERAPY_SERVICE", 18)}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>19</TableCell>
              <TableCell>होमियोप्याथी सेवा</TableCell>
              <TableCell>{circle("HOMEOPATHY_SERVICE", 19)}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>20</TableCell>
              <TableCell>प्राकृतिक चिकित्सा सेवा</TableCell>
              <TableCell>{circle("NATUROPATHY_SERVICE", 20)}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>21</TableCell>
              <TableCell>ल्याव सेवा</TableCell>
              <TableCell>{circle("LAB_SERVICE", 21)}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>22</TableCell>
              <TableCell>सोवारिग्पा चिकित्सा सेवा</TableCell>
              <TableCell>{circle("SOWARIGPA_SERVICE", 22)}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>23</TableCell>
              <TableCell>अन्य सेवा</TableCell>
              <TableCell>{circle("OTHER_SERVICE", 23)}</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </>
  )
}

export default AvailableServices;